import { Zap, Loader, CheckSquare, BanIcon } from "lucide-react";
import React from "react";
import { IVariant, TBadgeVariant } from "./types";

export const VARIANT_DEFAULTS: Record<TBadgeVariant, IVariant> = {
    default: {
        bgColor: "background-primary-50",
        color: "text-primary-900",
        iconColor: "text-primary-900"
    },
    tertiary: {
        bgColor: "background-tertiary-50",
        color: "text-tertiary-700",
        iconColor: "text-tertiary-500",
        icon: <Loader />
    },
    secondary: {
        bgColor: "background-secondary-50",
        color: "text-secondary-700",
        iconColor: "text-secondary-500",
        icon: <Zap />
    },
    success: {
        bgColor: "success-50",
        color: "success-700",
        iconColor: "success-700",
        icon: <CheckSquare />
    },
    error: {
        bgColor: "error-50",
        color: "error-700",
        iconColor: "error-700",
        icon: <BanIcon />
    }
};
